import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFoldersFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5194 3C13.0661 3 13.5863 3.22371 13.9616 3.61431L14.0811 3.75061L15.4806 5.5H20C21.0544 5.5 21.9182 6.31588 21.9945 7.35074L22 7.5V15C22 16.0544 21.1841 16.9182 20.1493 16.9945L20 17H18V19C18 20.0544 17.1841 20.9182 16.1493 20.9945L16 21H4C2.94564 21 2.08183 20.1841 2.00549 19.1493L2 19V9C2 7.94564 2.81588 7.08183 3.85074 7.00549L4 7H6V5C6 3.94564 6.81588 3.08183 7.85074 3.00549L8 3H12.5194ZM12.5194 5H8V7H8.51938C9.12694 7 9.70157 7.27618 10.0811 7.75061L11.4806 9.5H16C17.1046 9.5 18 10.3954 18 11.5V15H20V7.5H15.4806C14.8731 7.5 14.2984 7.22382 13.9189 6.74939L12.5194 5Z",
		fill: "currentColor"
	})
});
export default SvgFoldersFill;
